import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { environment } from 'environments/environment';
import { DesignSystemSigmaService } from 'app/services/design-system-sigma.service';
import { DssTemaEnum } from '../../../enums/dss-tema.enum';

@Component({
  selector: 'app-dss-layout',
  templateUrl: './dss-layout.component.html',
  styleUrls: ['./dss-layout.component.scss'],
})
export class DssLayoutComponent implements OnInit, OnDestroy {
  private readonly urlOriginSigmaClient = environment.urlOriginSigmaClient;
  private liberado: boolean = false;
  private themeCurrent: DssTemaEnum = DssTemaEnum.DARK;
  private readonly destroy$ = new Subject();

  constructor(private dssService: DesignSystemSigmaService) {}

  public ngOnInit(): void {
    this.liberado = true;
  }

  public ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  public isLiberado(): boolean {
    return this.liberado;
  }

  isDssLayout(): boolean {
    return this.dssService.isDssLayout();
  }

  isThemeDark(): boolean {
    return this.themeCurrent === DssTemaEnum.DARK;
  }
}
